{
  "zh-CN": {
    "nav": {
      "raffles": "抽奖",
      "raffle": "抽奖",
      "admin": {
        "raffles": {
          "index": "抽奖",
          "new": "新建抽奖",
          "edit": "编辑抽奖",
          "entries": "抽奖参与记录"
        }
      },
      "raffleClaim": "领取奖品",
      "settings": {
        "raffles": "我的抽奖"
      }
    },
    "title": {
      "raffles": "抽奖",
      "raffle": "抽奖",
      "admin": {
        "raffles": {
          "index": "抽奖",
          "new": "新建抽奖",
          "edit": "编辑抽奖",
          "entries": "抽奖参与记录"
        }
      },
      "raffleClaim": "领取奖品",
      "settings": {
        "raffles": "我的抽奖"
      }
    },
    "headlines": {
      "admin": {
        "raffles": {
          "index": "抽奖",
          "new": "新建抽奖",
          "edit": "编辑抽奖",
          "entries": "抽奖参与记录"
        }
      },
      "settings": {
        "raffles": "我的抽奖"
      }
    },
    "labels": {
      "raffle": {
        "title": "标题",
        "prize": "奖品",
        "prizeInfo": "中奖者获得的奖品，显示在抽奖旁边。发布时必填。",
        "description": "描述",
        "descriptionInfo": "Markdown。将舰船或物品写成 [*名称*] 即可链接；输入 [* 进行搜索。",
        "translationInfo": "可选。留空的字段将显示英文内容。",
        "importFolderInfo": "从一个文件夹一次性填写所有语言和图库：每种语言一个 en.md、de.md……，在 front matter 块中写标题和奖品，另附图片。点击保存之前不会保存任何内容。",
        "imagesUploading": "正在上传图片：%{count}",
        "code": "礼品码",
        "codeInfo": "中奖者获得的礼品码。它会加密存储，且不会再完整显示。",
        "codeSet": "已设置礼品码（%{code}）。留空此字段即可保留它。",
        "codeFrozen": "开奖后无法再更改礼品码。",
        "startsAt": "开始时间",
        "endsAt": "截止时间",
        "claimPeriodDays": "领取期限（天）",
        "claimPeriodDaysInfo": "中奖者点击领取邮件中链接的时限，超时后中奖资格将顺延给下一位。",
        "published": "已发布",
        "publishedInfo": "只有已发布的抽奖才会被列出并开放参与。发布前需要设置礼品码。",
        "status": "状态",
        "entriesCount": "参与数",
        "entriesCountValue": "参与数：%{count}",
        "statuses": {
          "draft": "草稿",
          "upcoming": "即将开始",
          "open": "进行中",
          "closed": "已截止",
          "drawn": "已开奖",
          "concluded": "已结束"
        },
        "drawnInfo": "已开奖",
        "drawnBy": "由 %{admin} 于 %{date} 开奖。",
        "currentWinner": "当前中奖者：%{username}",
        "claimDeadline": "领取截止：%{date}",
        "runDays": "持续时间（天）",
        "runDaysInfo": "抽奖从开始起开放参与的天数。",
        "images": "图片",
        "imagesInfo": "第一张图片将作为卡片和首页上的封面。",
        "cover": "封面",
        "socialPosts": "X 帖子",
        "claimedInfo": "于 %{date} 领取。礼品码邮件：%{mail}。",
        "claimPending": "领取链接已发送至 %{email}（%{mail}）。领取期限于 %{date} 结束。",
        "overview": {
          "title": "概览",
          "prize": "奖品",
          "code": "礼品码",
          "noCode": "未设置",
          "startsAt": "开始",
          "endsAt": "结束",
          "runDays": "持续时间",
          "claimPeriodDays": "领奖期限",
          "days": "%{days} 天",
          "startAnnouncedAt": "开始通知",
          "lastDayAnnouncedAt": "最后一天提醒",
          "drawnAt": "已开奖",
          "drawnBy": "%{date}，由 %{admin}",
          "concludedAt": "已结束",
          "publicPage": "打开公开页面",
          "noImages": "还没有图片。发布需要至少一张。",
          "previewInfo": "一个链接，任何持有者都能查看此抽奖（包括草稿），无需账号。有效期 30 天。",
          "copyPreview": "复制预览链接",
          "openPreview": "打开预览"
        }
      },
      "raffleEntry": {
        "username": "参与者",
        "drawPosition": "顺位",
        "conditionsAcceptedAt": "已接受条款",
        "state": "状态",
        "accountDeleted": "账户已删除",
        "states": {
          "claimed": "已领取",
          "forfeited": "已失效",
          "passedOver": "已顺延",
          "winner": "中奖者",
          "waiting": "候补中",
          "notDrawn": "不符合资格"
        },
        "mail": "邮件",
        "claimMail": "领取邮件",
        "prizeMail": "礼品码邮件",
        "mailStatuses": {
          "sent": "已发送",
          "delivered": "已送达",
          "bounced": "已退回"
        },
        "warnings": "警告",
        "warningLabels": {
          "sharedIp": "相同 IP",
          "sameInbox": "相同邮箱",
          "newAccount": "新账户",
          "noEmail": "无邮箱"
        },
        "warningDetails": {
          "sharedIp": "与以下用户登录 IP 相同：%{usernames}。常见于同一家庭或移动网络。",
          "sameInbox": "与以下用户邮箱相同：%{usernames}。很可能是同一个人。",
          "newAccount": "账户创建不到一天后即参与。",
          "noEmail": "账户没有邮箱地址。抽奖时将被跳过。"
        }
      },
      "admin": {
        "resourceAccess": {
          "privileges": {
            "raffles": "抽奖"
          }
        }
      },
      "notificationTypes": {
        "raffle_won": "抽奖中奖",
        "raffle_started": "抽奖已开始",
        "raffle_last_day": "抽奖即将截止",
        "raffle_email_missing": "参与抽奖需要邮箱地址"
      }
    },
    "placeholders": {
      "raffle": {
        "title": "赢取一艘 Polaris",
        "description": "奖品内容及参与方式",
        "code": "XXXX-XXXX-XXXX",
        "claimPeriodDays": "3",
        "runDays": "14",
        "prize": "Anvil Polaris 游戏包"
      }
    },
    "messages": {
      "raffle": {
        "created": "抽奖已创建。",
        "updated": "抽奖已更新。",
        "destroyed": "抽奖已删除。",
        "createFailed": "无法创建抽奖。",
        "updateFailed": "无法更新抽奖。",
        "drawn": "已开奖。",
        "drawFailed": "无法开奖。",
        "invalid": "请检查标记的字段：抽奖需要标题、开始时间和持续时间。",
        "imported": "文件夹已导入（语言：%{languages}，图片：%{images}）。请检查表单后保存。",
        "importSkipped": "已跳过的文件：%{files}",
        "importEmpty": "该文件夹中既没有语言文件也没有图片。",
        "importUploadFailed": "以下图片无法上传：%{files}"
      },
      "confirm": {
        "raffle": {
          "destroy": "确定要删除此抽奖吗？此操作无法撤销。",
          "draw": "现在开奖吗？所有参与者的顺序将永久确定，且无法重新抽取。"
        }
      }
    },
    "actions": {
      "raffle": {
        "entries": "参与记录",
        "draw": "开奖",
        "importFolder": "导入文件夹"
      }
    },
    "raffles": {
      "title": "抽奖",
      "lead": "赢取 Star Citizen 舰船的礼品码。参与进行中的抽奖；抽奖截止后，将随机抽出中奖者。",
      "empty": "目前没有抽奖活动。",
      "status": "状态",
      "runs": "活动时间",
      "endsAt": "%{date} 截止",
      "entriesCount": "参与者：%{count}",
      "entered": "您已参与此抽奖。",
      "statuses": {
        "draft": "草稿",
        "upcoming": "即将开始",
        "open": "进行中",
        "closed": "已截止，等待开奖",
        "drawn": "已开奖",
        "concluded": "已结束"
      },
      "entrants": {
        "title": "参与者",
        "empty": "还没有人参与。",
        "count": "参与者",
        "titleCount": "参与者 · %{count}",
        "showAll": "显示全部 %{count} 位"
      },
      "winner": {
        "title": "中奖者",
        "pending": "%{username} 中奖了，需在 %{date} 前领取礼品码。",
        "claimed": "%{username} 中奖了，并已领取礼品码。",
        "forfeited": "未按时领取",
        "claimedPill": "已领取",
        "until": "截至 %{date}",
        "drawnOn": "已于 %{date} 从 %{count} 位参与者中抽出。"
      },
      "over": {
        "title": "本次抽奖已结束",
        "closed": "报名已截止，即将抽出获奖者。",
        "drawn": "报名已截止，获奖者已抽出。",
        "concluded": "本次抽奖已结束，感谢所有参与者。"
      },
      "won": {
        "title": "您中奖了！",
        "checkMail": "我们已向您发送一封邮件，其中包含领取奖品的链接。请在 %{date} 前点击该链接，否则中奖资格将顺延给下一位。",
        "claimed": "奖品已领取",
        "codeSent": "您的礼品码正在发送到您的邮箱。"
      },
      "actions": {
        "enter": "参与抽奖",
        "withdraw": "退出",
        "signInToEnter": "登录后参与此抽奖",
        "addEmail": "添加邮箱地址"
      },
      "messages": {
        "entered": "您已参与抽奖。祝您好运！",
        "withdrawn": "您已退出抽奖。",
        "confirmWithdraw": "退出此抽奖？",
        "forbidden": "只有已验证电子邮箱的账户才能参与。请验证您的电子邮箱后重试。",
        "failed": "出现问题，请重试。"
      },
      "conditions": {
        "title": "参与条款",
        "accept": "我已阅读并接受参与条款。",
        "confirmedAccount": "只有已验证电子邮箱的账户才能参与，每个账户限参与一次。",
        "noMaintainers": "Fleetyards 维护者不能参与。",
        "publicEntrants": "您的用户名将作为参与者公开显示在此页面上。",
        "publicWinner": "如果您中奖，您的用户名将作为中奖者公开显示。",
        "drawOrder": "抽奖截止后，所有符合资格的参与者将被随机排成一个顺序。排在第一位的参与者中奖。",
        "claimMail": "中奖者将收到一封包含领取奖品链接的邮件。奖品绝不会在本网站上显示。",
        "claimDeadline": "中奖者需在 %{days} 天内点击该链接。如未按时点击，中奖资格将顺延给下一位，下一位将收到自己的邮件。",
        "prizeMail": "点击该链接后，礼品码将通过邮件发送到中奖账户的电子邮箱。",
        "deletedAccount": "轮到时账户不再处于已验证状态的参与者将被跳过。如果你删除了账户，你的参与记录会保留，中奖通知将发送到你参与时使用的邮箱地址。",
        "noCash": "奖品仅为礼品码，不提供现金替代，也不可兑换为其他奖品。",
        "noLiability": "Fleetyards 不对礼品码、其有效性或兑换承担责任，也不对您的 RSI 账户出现的任何问题承担责任。",
        "noRecourse": "抽奖结果为最终结果，不得通过法律途径追诉。",
        "notAffiliated": "Fleetyards 是非官方粉丝网站，与 Cloud Imperium Games 无任何关联。",
        "version": "条款版本 %{version}"
      },
      "claim": {
        "title": "领取奖品",
        "pending": "正在领取您的奖品…",
        "success": "您已领取“%{raffle}”中的奖品。礼品码正在发送到您的邮箱。",
        "failedTitle": "无法领取奖品",
        "failed": "出现问题，请重新打开该链接。"
      },
      "meta": "%{date} 截止 · %{count} 位参与者",
      "metaClosed": "已于 %{date} 截止 · %{count} 位参与者",
      "showImage": "显示图片 %{index}",
      "howItWorks": {
        "title": "参与方式",
        "enter": {
          "title": "%{date} 前参与",
          "text": "接受参与条款即可参与。抽奖截止前，您可以随时退出。"
        },
        "draw": {
          "title": "抽奖",
          "text": "截止后，所有参与者将被随机排成一个顺序。排在第一位的参与者中奖。"
        },
        "claim": {
          "title": "%{days} 天内领取",
          "text": "中奖者将收到一封包含领取链接的邮件。如 %{days} 天内未点击，下一位将收到自己的邮件。"
        },
        "code": {
          "title": "礼品码通过邮件发送",
          "text": "点击该链接后，礼品码将通过邮件发送。礼品码绝不会在本网站上显示。"
        }
      },
      "entry": {
        "prize": "奖品",
        "title": "参与抽奖",
        "yours": "您的参与",
        "closes": "截止",
        "closed": "已截止",
        "claimPeriod": "领取期限",
        "days": "%{days} 天",
        "entered": "您已参与。抽奖将在 %{date} 后进行。",
        "enteredHint": "如果您中奖，我们将向您发送领取链接。抽奖后 %{days} 天内请留意您的邮箱。",
        "over": "抽奖已结束",
        "opensAt": "%{date} 开始。",
        "maintainer": "维护者负责管理抽奖，不能参与。",
        "emailRequired": "请先为账户添加邮箱地址再参与。奖品通过邮件发送，而你的账户还没有邮箱地址。",
        "emailMissing": "你的账户没有邮箱地址，奖品无法送达，你的参与将在抽奖时被跳过。请在 %{date} 前添加一个。"
      },
      "slider": {
        "label": "图片轮播",
        "previous": "上一张图片",
        "next": "下一张图片"
      },
      "home": {
        "view": "查看抽奖",
        "panelTitle": "抽奖",
        "entered": "已参与",
        "notEntered": "您尚未参与。",
        "enter": "参与",
        "pillTag": "抽奖",
        "endsIn": {
          "one": "%{count} 天后结束",
          "other": "%{count} 天后结束"
        },
        "endsToday": "今天结束"
      },
      "mine": {
        "raffle": "抽奖",
        "enteredAt": "参与时间",
        "outcome": "结果",
        "claimBy": "请查收邮件并在 %{date} 前领取",
        "outcomes": {
          "open": "进行中",
          "waiting": "等待开奖",
          "won": "已中奖",
          "claimed": "已领取",
          "forfeited": "未按时领取",
          "not_won": "未中奖"
        }
      },
      "preview": {
        "title": "预览",
        "text": "你正在通过预览链接查看此抽奖。在发布之前，只有持有该链接的人才能看到它。"
      }
    }
  }
}
